import * as types from './action-types.js';

export const successGetCustomers = (data) => {
  return {
    type: types.SUCCESS_GET_CUSTOMERS,
    data,
  };
};
